// extracted by mini-css-extract-plugin
export var content = "gray-accordion-section-module--content--wJ0Ep";
export var contentMobile = "gray-accordion-section-module--content-mobile--LPcj5";
export var description = "gray-accordion-section-module--description--gMx46";
export var display = "gray-accordion-section-module--display--knTx1";
export var image = "gray-accordion-section-module--image--OOaHV";
export var innerWrapper = "gray-accordion-section-module--inner-wrapper--A9f9s";
export var outerWrapper = "gray-accordion-section-module--outer-wrapper--NZofQ";
export var tab = "gray-accordion-section-module--tab--jJBni";
export var tabActive = "gray-accordion-section-module--tab-active--udJQJ";
export var tabs = "gray-accordion-section-module--tabs--Rbsfu";
export var text = "gray-accordion-section-module--text--Q+jgz";
export var title = "gray-accordion-section-module--title--PK1yU";
export var titleTextOuterWrapper = "gray-accordion-section-module--title-text-outer-wrapper--amJgT";
export var wrapper = "gray-accordion-section-module--wrapper--w6GqZ";